// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SpeakerVolumeLowIconSignature {
  Element: SVGSVGElement;
}

export const SpeakerVolumeLowIcon: TOC<SpeakerVolumeLowIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.586 3.586C10.149 3.021 11.025 2.846 11.764 3.152C12.515 3.462 13 4.187 13 5V19C13 19.813 12.515 20.54 11.764 20.849C11.521 20.949 11.263 21 11 21C10.434 21 9.891 20.777 9.474 20.28L6.479 16H4C2.897 16 2 15.103 2 14V10C2 8.896 2.897 8 4 8H6.479L9.586 3.586ZM4 14H7.521L11.001 18.975L11 5.028L7.521 10H4V14Z"/>
</svg>
</template>;